import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Tabs from "components/lib/Shared/Tabs";
import TransactionBRSEsignature from "./TransactionBRSEsignature";
import { ChevronLeftIcon } from "@heroicons/react/outline";

/**
 * ESignature component for handling e-signature flows for directors and shareholders.
 * Shows a signing UI or a loading spinner depending on data readiness.
 *
 * @param {function} handleConfirmDetails - Callback to confirm details after signing
 * @param {object} selectedTab - The currently selected tab (director/shareholder approval)
 */
const BRSFormsESignature = ({ handleConfirmDetails, goToPrevStep }) => {
  /** Redux states and hooks */
  const { transactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );

  /** Tabs setting */
  const transactions = transactionUnderReview.items.transactions;
  const initialTabs = transactions.map((trx, index) => {
    return {
      label: `Transaction ${index + 1}`,
      id: index,
    };
  });
  const [tabs, setTabs] = useState(initialTabs);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  /** Check if is last step */
  const isLastStep = selectedTabIndex === tabs?.length - 1;
  const isFirstStep = selectedTabIndex === 0;

  /** Go to next tab */
  const goToNextStep = () => {
    setSelectedTabIndex((current) => current + 1);
  };

  const goBack = () => {
    if (selectedTabIndex === 0) {
      goToPrevStep();
    } else {
      setSelectedTabIndex((current) => current - 1);
    }
  };

  /** Effects */

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">BRS Forms</h2>
      <div>
        <Tabs
          tabs={tabs}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
        />
      </div>
      <div>
        {transactions.map((trx, index) => {
          if (selectedTabIndex === index) {
            return (
              <TransactionBRSEsignature
                transaction={trx}
                handleConfirmDetails={handleConfirmDetails}
                isLastStep={isLastStep}
              />
            );
          }
        })}
      </div>
      <div className="justify justify-between mt-3">
        <button
          onClick={goBack}
          className="flex items-start  py-2 font-semibold rounded"
        >
          <span className="flex items-center mr-4 h-7">
            <ChevronLeftIcon
              className="flex-shrink-0 w-5 h-5"
              aria-hidden="true"
            />
          </span>
          <p className="font-semibold">Go back</p>
        </button>
        {tabs?.length > 1 && !isLastStep && (
          <div>
            <button onClick={goToNextStep}>Next</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default BRSFormsESignature;
